module.exports = __webpack_public_path__ + "static/media/jialishan2.cb881e4d.jpg";